import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { fetchWithAuth } from '../utils/authUtils';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
const DETAIL_CACHE_TTL_MS = 45 * 60 * 1000;

const useQuery = () => new URLSearchParams(useLocation().search);

const BlogExternalDetail = () => {
  const query = useQuery();
  const link = query.get('link') || query.get('url') || '';
  const refresh = query.get('refresh') || '';
  const [title, setTitle] = useState('');
  const [html, setHtml] = useState('');
  const [source, setSource] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let aborted = false;
    (async () => {
      try {
        if (!link) {
          setError('Thiếu tham số link');
          return;
        }
        const cacheKey = `tamcare:external-blog:${link}`;
        const cached = !refresh ? (() => {
          try {
            const raw = sessionStorage.getItem(cacheKey);
            if (!raw) return null;
            const parsed = JSON.parse(raw);
            return parsed && (Date.now() - parsed.ts) < DETAIL_CACHE_TTL_MS ? parsed.data : null;
          } catch { return null; }
        })() : null;
        if (cached) {
          setTitle(cached.title || '');
          setHtml(cached.html || '');
          setSource(cached.source || cached.url || link);
        }
        setLoading(!cached);
        setError('');
        const url = `${API_BASE}/api/blogs-external-detail?link=${encodeURIComponent(link)}${refresh ? `&refresh=${encodeURIComponent(refresh)}` : ''}`;
        const res = await fetchWithAuth(url).catch(() => null);
        if (!res) { if (!aborted && !cached) setError('Không thể tải bài viết.'); return; }
        const json = await res.json().catch(() => ({}));
        if (!json?.success) {
          if (!aborted && !cached) setError(json?.message || 'Không thể tải bài viết.');
          return;
        }
        if (aborted) return;
        setTitle(json.data?.title || '');
        setHtml(json.data?.html || '');
        setSource(json.data?.source || json.data?.url || link);
        try {
          sessionStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), data: json.data || {} }));
        } catch {}
      } catch (e) {
        if (!aborted) setError(e?.message || 'Lỗi khi tải bài viết.');
      } finally {
        if (!aborted) setLoading(false);
      }
    })();
    return () => { aborted = true; };
  }, [link, refresh]);

  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'referrer';
    meta.content = 'no-referrer';
    document.head.appendChild(meta);
    return () => {
      try { document.head.removeChild(meta); } catch {}
    };
  }, []);

  return (
    <div style={{ background: '#f4f7f6', minHeight: '100vh' }}>
      <div style={{ maxWidth: 850, margin: '0 auto', padding: '96px 16px 48px' }}>
        {loading && (
          <div>
            <div style={{ height: 28, width: '60%', background: '#e2e8f0', borderRadius: 8, margin: '12px 0' }} />
            <div style={{ height: 14, width: '40%', background: '#e2e8f0', borderRadius: 8, marginBottom: 16 }} />
            <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e2e8f0', padding: 18 }}>
              {[...Array(8)].map((_, i) => (
                <div key={i} style={{ height: 12, background: '#e2e8f0', borderRadius: 6, margin: '10px 0', width: `${80 - i * 5}%` }} />
              ))}
            </div>
          </div>
        )}
        {error && <div className="tamcare-alert tamcare-alert--error">{error}</div>}
        {!loading && !error && !html && <div className="tamcare-alert">Không tìm thấy nội dung.</div>}

        {!loading && !error && (
          <article style={{ background: '#fff', borderRadius: 15, overflow: 'hidden', boxShadow: '0 5px 20px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0', padding: 32 }}>
            <Link to="/blogs" style={{ display: 'inline-block', marginBottom: 20, color: '#2c5282', textDecoration: 'none', fontWeight: 'bold' }}>
              <span style={{ marginRight: 8 }}>←</span>Quay lại danh sách tin
            </Link>
            <h1 style={{ fontSize: 32, color: '#1a365d', lineHeight: 1.3, margin: '0 0 24px 0' }}>{title}</h1>
            <div className="tamcare-content-body" style={{ fontSize: 20, color: '#334e68' }} dangerouslySetInnerHTML={{ __html: html }} />
            {source && (
              <div style={{ marginTop: 40, paddingTop: 20, borderTop: '1px solid #eee', fontStyle: 'italic', color: '#718096' }}>
                Nguồn nội dung: {(() => { try { return new URL(source).hostname; } catch { return source; } })()}
              </div>
            )}
            <style>{`
              .tamcare-content-body img { max-width: 100% !important; height: auto !important; border-radius: 10px; margin: 20px 0; }
              .tamcare-content-body iframe { max-width: 100%; }
              .tamcare-content-body figure { margin: 0; }
            `}</style>
          </article>
        )}
      </div>
    </div>
  );
};

export default BlogExternalDetail;
